// GET SEARCH SAP
const SEARCH_SAP_GET_DATA = {
  SEARCH_SAP_GET_DATA_LOAD: "SEARCH_SAP_GET_DATA_LOAD",
  SEARCH_SAP_GET_DATA_SUCCESS: "SEARCH_SAP_GET_DATA_SUCCESS",
  SEARCH_SAP_GET_DATA_FAIL: "SEARCH_SAP_GET_DATA_FAIL",
};

const SEARCH_SAP_GET_DETAIL_API = "/store/searchBySAP/";

// POST STORE VISIT
const STORE_CALL_VISIT_POST = {
  STORE_CALL_VISIT_POST_LOAD: "STORE_CALL_VISIT_POST_LOAD",
  STORE_CALL_VISIT_POST_SUCCESS: "STORE_CALL_VISIT_POST_SUCCESS",
  STORE_CALL_VISIT_POST_FAIL: "STORE_CALL_VISIT_POST_FAIL",
};

// GET STORE VISIT LIST
const STORE_CALL_VISIT_GET = {
  STORE_CALL_VISIT_GET_LOAD: "STORE_CALL_VISIT_GET_LOAD",
  STORE_CALL_VISIT_GET_SUCCESS: "STORE_CALL_VISIT_GET_SUCCESS",
  STORE_CALL_VISIT_GET_FAIL: "STORE_CALL_VISIT_GET_FAIL",
};

const STORE_CALL_VISIT_API = "/app/store-call-visit";

// POST SEND MAIL
const STORE_CALL_VISIT_SEND_MAIL_POST = {
  STORE_CALL_VISIT_SEND_MAIL_POST_LOAD: "STORE_CALL_VISIT_SEND_MAIL_POST_LOAD",
  STORE_CALL_VISIT_SEND_MAIL_POST_SUCCESS: "STORE_CALL_VISIT_SEND_MAIL_POST_SUCCESS",
  STORE_CALL_VISIT_SEND_MAIL_POST_FAIL: "STORE_CALL_VISIT_SEND_MAIL_POST_FAIL",
};
const STORE_CALL_VISIT_SEND_MAIL_POST_API = "/app/store-call-visit/send-email";

const STORE_CALL_VISIT_GET_VENDOR_DATA = {
  STORE_CALL_VISIT_GET_VENDOR_DATA_LOAD: "STORE_CALL_VISIT_GET_VENDOR_DATA_LOAD",
  STORE_CALL_VISIT_GET_VENDOR_DATA_SUCCESS: "STORE_CALL_VISIT_GET_VENDOR_DATA_SUCCESS",
  STORE_CALL_VISIT_GET_VENDOR_DATA_FAIL: "STORE_CALL_VISIT_GET_VENDOR_DATA_FAIL",
};
const STORE_CALL_VISIT_VENDOR_API = "/app/store-call-visit/vendors";


export {
  SEARCH_SAP_GET_DATA,
  SEARCH_SAP_GET_DETAIL_API,
  STORE_CALL_VISIT_POST,
  STORE_CALL_VISIT_GET,
  STORE_CALL_VISIT_API,
  STORE_CALL_VISIT_SEND_MAIL_POST,
  STORE_CALL_VISIT_SEND_MAIL_POST_API,
  STORE_CALL_VISIT_GET_VENDOR_DATA,
  STORE_CALL_VISIT_VENDOR_API,
};